module.exports = __webpack_public_path__ + "img/lince.eea570a9.png";